@if (profileField$ | async; as profileField) {
  <sh-form-group
    [id]="profileField.FieldDefinition.FlatKey"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [required]="profileField.Required"
    [helpText]="profileField.Description"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [title]="disabledMessageKey | translate"
    [labelActionItems]="globalActionItems$ | async"
    >
    @if (isIndeterminate) {
      <p class="sh-form-group__feedback">{{ "general.only-matching-values-shown" | translate }}</p>
    }
    <!-- Merge Strategy Component-->
    <div slot="inputPrefix">
      <ng-content></ng-content>
    </div>
    <form [formGroup]="list" [id]="profileField.DottedKey">
      @for (currentValueFormGroup of list.controls; track currentValueFormGroup; let i = $index) {
        <div class="sh-form-group sh-child-field-group" [style]="nestedPadding$ | async">
          <div class="sh-action-group" style="margin-bottom: 0px">
            <div class="sh-action-group__item">
              <label
                ><i>{{ childDefinitionLabel$ | async }} {{ i + 1 }}</i></label
                >
              </div>
              @if (childActionItems$ | async; as actionItems) {
                <div class="sh-action-group__item">
                  @for (actionItem of actionItems[i]; track actionItem) {
                    <sh-action-item [item]="actionItem"></sh-action-item>
                  }
                </div>
              }
            </div>
            @for (grandChildProfileField of grandChildProfileFields$ | async; track grandChildProfileField) {
              @if (grandChildProfileField.FieldDefinition) {
                <sh-generic-field
                  [profileField]="grandChildProfileField"
                  [formGroup]="currentValueFormGroup"
                  [records]="[flattenedComplexListFieldRecords[i]]"
                  [isBatchEdit]="isBatchEdit"
                  [canEditStandard]="canEdit$ | async"
                  [canEditAdvanced]="canEdit$ | async"
                  [nestedIndex]="(nestedIndex$ | async)! + 1"
                  [autocompleteFct]="undefined"
                  >
                </sh-generic-field>
              } @else {
                <dt class="sh-description-list__term">{{ grandChildProfileField.DisplayLabel }}</dt>
                <dd class="sh-description-list__details">
                  {{ "form.error.fielddefinition-not-found" | translate: { id: grandChildProfileField.FieldDefinitionId } }}
                </dd>
              }
            }
          </div>
        }
      </form>
    </sh-form-group>
  }
